import { render, staticRenderFns } from "./BrowserNotSupported.vue?vue&type=template&id=79ea3d74&scoped=true&"
import script from "./BrowserNotSupported.vue?vue&type=script&lang=js&"
export * from "./BrowserNotSupported.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/browser_message.css?vue&type=style&index=0&id=79ea3d74&prod&scoped=true&lang=css&"
import style1 from "@/assets/css/sp/browser_message.css?vue&type=style&index=1&id=79ea3d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ea3d74",
  null
  
)

export default component.exports